import { render } from "./center-list-item.vue?vue&type=template&id=c3461464&scoped=true&ts=true"
import script from "./center-list-item.vue?vue&type=script&lang=ts"
export * from "./center-list-item.vue?vue&type=script&lang=ts"

import "./center-list-item.vue?vue&type=style&index=0&id=c3461464&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3461464"]])

export default __exports__